import React, { ReactElement } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { GridRowSelectionModel } from "@mui/x-data-grid/models/gridRowSelectionModel";

type Props = {
  onDelete(): void;
  selectedIds: GridRowSelectionModel;
};

const ActionToolbar = ({ onDelete, selectedIds }: Props): ReactElement => {
  function handleClickDelete(evt: React.MouseEvent) {
    evt.preventDefault();
    onDelete();
  }

  if (selectedIds.length) {
    return (
      <>
        <Grid>
          <Tooltip title="Delete">
            <span>
              <Button
                aria-label="delete"
                color="primary"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={handleClickDelete}
              >
                Delete
              </Button>
            </span>
          </Tooltip>
        </Grid>
      </>
    );
  }

  return <></>;
};
export default ActionToolbar;
